import ReactGA from "react-ga";

export function gaEvent({ category, action, label, options = {} }) {
  try {
    if (
      process.env.NODE_ENV === "production" ||
      process.env.NODE_ENV === "staging"
    ) {
      ReactGA.event({ category, action, label, options });
    }
  } catch (err) {
    console.log(err);
  }
}



// WEBPACK FOOTER //
// ./src/newDropshipperApp/utils/trackEvents.js